import { Component, Input, OnInit } from '@angular/core';
import { Helper } from '../../utilities/classes/helper.class';
import { AccSimpleInputTextFormInterface } from '../acc-simple-input-text-form/acc-simple-input-text-form.component';
import { FormGroup } from '@angular/forms';
import { finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-acc-simple-input-text-form-fixed',
  templateUrl: './acc-simple-input-text-form-fixed.component.html',
  styleUrls: ['./acc-simple-input-text-form-fixed.component.scss']
})
export class AccSimpleInputTextFormFixedComponent implements OnInit {

  public readonly Helper = Helper;

  @Input('data') public data: AccSimpleInputTextFormInterface | undefined = undefined;

  public fg: FormGroup | undefined;

  constructor() { }

  public ngOnInit(): void {
    this.fg = this._newFg();
  }

  public onSubmit() {
    if (Helper.getInvalidControls(this.fg).length) return;
    // if (this.fg) this.finalArgs?.onSubmit(this.fg.value, this.ref, this.finalArgs);
    if (this.fg) this.data?.onSubmit(
      this.fg.value,
      null,
      this.data
    );
  }

  private _newFg() {
    let controls = {};
    this.data?.controls.forEach(c => {

      const rValidators = c.required ? [Helper.reactiveForms.validatos.required] : [];
      const cValidators = c.validators ?? [];
      const asyncValidators = c.asyncValidators ?? [];

      const control = Helper.reactiveForms.control<unknown>(c.initialValue, [...cValidators, ...rValidators], [...asyncValidators]);
      if (c.disabled) control.disable();

      if (c.onValueChanges) {
        const subs: Subscription = control.valueChanges.pipe(
          finalize(() => subs.unsubscribe()),
        ).subscribe(newVal => {
          if (!this.fg) return null;
          return c.onValueChanges ? c.onValueChanges(newVal, this.fg) : null;
        });
      }

      controls = { ...controls, [`${c.name}`]: control };
    });

    return new FormGroup(controls);
  }


}